const config = {
  env: 'local',
   apiUrl: "https://api.astroconsult.in/api/",
 //  apiUrl: "http://192.168.0.24:5500/api/",
}

export default config;